import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { string as yupString } from "yup";
import { findMessageForCode } from "../../utils/secret-questions/map-codes-to-options";
import TextInputField from "../shared/fields/text-input-field";
import messages from "./secret-question-answer-messages";

const SecretQuestionAnswer = ({ secretQuestionCode, ...rest }) => {
  const { formatMessage } = useIntl();
  const labelMessage = findMessageForCode(secretQuestionCode);

  const secretQuestionAnswerValidationSchema = yupString().required(
    formatMessage(messages.required)
  );

  return (
    <TextInputField
      label={formatMessage(labelMessage)}
      id="secret-question-answer"
      name="secretQuestionAnswer"
      validationSchema={secretQuestionAnswerValidationSchema}
      {...rest}
    />
  );
};

SecretQuestionAnswer.propTypes = {
  secretQuestionCode: PropTypes.string.isRequired
};

export default SecretQuestionAnswer;
